'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var theme = {
  checkedBg: '#19AB27',
  checkedBgHover: '#128D15',
  notCheckedBg: '#4D4D4D',
  notCheckedBgHover: '#000000',
  checkedBorder: '#19AB27',
  notCheckedBorder: '#4D4D4D',
  thumbBg: '#FAFAFA'
};
exports.default = theme;